<template>
  <Record :title="prompt.name">
    <RowGrid>
      <Set icon="brain" :label="$t('engine')">
        {{ (prompt.adjustments || {}).engine | fallback }}
      </Set>
      <Set icon="record" :label="$t('type')">
        {{ prompt.type }}
      </Set>
      <Set icon="record" :label="$t('category')">
        {{ prompt.category }}
      </Set>
    </RowGrid>
    <Set icon="record" :label="$t('template')">
      {{ prompt.template.slice(0, 100) }}
    </Set>
    <RecordActions
      slot="actions"
      :doShowDelete="hasRole('>=ADMIN')"
      name="prompt"
      :record="prompt"
      routeName="Prompt" />
  </Record>
</template>

<script>
import Record from '@components/Record'
import RecordActions from '@components/RecordActions'
import Set from '@components/Set'
import { getters } from '@utils'

export default {
  components: { Record, RecordActions, Set },
  props: {
    prompt: Object,
  },
  computed: {
    specType() {
      if (!this.prompt.specTypeId) return

      return this.query('specType', this.prompt.specTypeId)
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "engine": "Engine",
    "category": "Category",
    "spec": "Spec",
    "template": "Template",
    "type": "Type"
  }
}
</i18n>
